
import { useState, useCallback } from "react";
import { AIStaffRole, AIStaffCandidate } from "@/lib/types";
import { useAllStaff } from "./useAllStaff";
import { useToast } from "@/hooks/use-toast";

export function useStaffSelection() {
  const [selectedCandidate, setSelectedCandidate] = useState<AIStaffCandidate | null>(null);
  const { allAIStaff, isRoleAlreadyOnboarded } = useAllStaff();
  const { toast } = useToast();

  const handleSelectCandidate = useCallback((candidate: AIStaffCandidate) => {
    // Check if this role is already onboarded (and active)
    if (isRoleAlreadyOnboarded(candidate.role as AIStaffRole)) {
      toast({
        title: "Role Already Exists",
        description: `You already have an active ${candidate.role} assistant. Terminate it first if you want to create a new one.`,
        variant: "destructive",
      });
      return;
    }
    
    setSelectedCandidate(candidate);
  }, [isRoleAlreadyOnboarded, toast]);

  return {
    selectedCandidate,
    setSelectedCandidate,
    handleSelectCandidate,
  };
}
